import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Service Areas', path: '/service-areas' },
    { name: 'Free Tools', path: '/calculators' },
    { name: 'Industries', path: '/industries' },
    { name: 'Case Studies', path: '/case-studies' },
    { name: 'About', path: '/about' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-4 left-0 right-0 z-50 px-4 md:px-10 lg:px-16">
      <div className="flex items-center justify-between glass rounded-full pl-3 pr-2 py-2">
        {/* Logo + wordmark */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer"
        >
          <img
            src="/logo.png"
            alt="Florida AI Marketing Experts"
            className="h-10 w-10 rounded-full object-cover"
          />
          <span className="h-display text-base md:text-lg tracking-tight leading-tight whitespace-nowrap">
            Florida <span style={{ color: '#0D9488' }}>AI</span> Marketing Experts
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-0.5">
          {navLinks.map((link) => (
            <button
              key={link.path}
              onClick={() => navigate(link.path)}
              className={`px-3.5 py-2 text-sm font-body font-medium transition-colors cursor-pointer ${
                isActive(link.path) ? 'text-teal-500' : 'text-slate-700 hover:text-teal-500'
              }`}
            >
              {link.name}
            </button>
          ))}
          <button
            onClick={() => navigate('/audit')}
            className="fdme-cta px-4 py-2 text-sm flex items-center gap-1.5 ml-1"
          >
            Free AI Audit <i className="ri-arrow-right-up-line"></i>
          </button>
        </nav>

        {/* Mobile toggle */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-slate-700"
          aria-label="Toggle menu"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden mt-3 glass-strong rounded-3xl p-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <button
                key={link.path}
                onClick={() => {
                  navigate(link.path);
                  setIsMobileMenuOpen(false);
                }}
                className={`text-sm font-body font-medium text-left px-4 py-2.5 rounded-xl transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-teal-500 bg-teal-50'
                    : 'text-slate-700 hover:text-teal-500 hover:bg-teal-50'
                }`}
              >
                {link.name}
              </button>
            ))}
            <button
              onClick={() => {
                navigate('/audit');
                setIsMobileMenuOpen(false);
              }}
              className="fdme-cta mt-2 px-5 py-3 text-sm flex items-center justify-center gap-2"
            >
              Free AI Audit <i className="ri-arrow-right-up-line"></i>
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
